import React, { useMemo } from 'react';
import {
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
} from '@heroicons/react/24/outline';
import styles from '../../../../styles/automation/scriptdetails.module.scss';

export default function InfoBox({ title, description, type = 'info', customIcon = null }) {
    const typeClass = useMemo(() => {
        switch (type) {
            case 'warning':
                return 'warning';
            case 'error':
                return 'error';
            default:
                return 'info';
        }
    }, [type]);

    return (
        <div className={`${styles.infoBox} ${styles[typeClass]}`}>
            {type === 'info' && !customIcon && (
                <InformationCircleIcon className={`icon-medium ${styles.infoIcon}`} />
            )}
            {type === 'warning' && !customIcon && (
                <ExclamationTriangleIcon className={`icon-medium ${styles.warningIcon}`} />
            )}
            {type === 'error' && !customIcon && (
                <ExclamationCircleIcon className={`icon-medium ${styles.errorIcon}`} />
            )}
            {customIcon}
            <div className={styles.infoContent}>
                <strong>{title}</strong>
                <p>{description}</p>
            </div>
        </div>
    );
}
